import React, { lazy, useEffect } from 'react'
import { Redirect, Router, Switch } from 'react-router-dom'
import history from './routerHistory'
import GlobalStyle from './style/Global'
import PageLoader from './components/PageLoader'
import SuspenseWithChunkError from './components/SuspenseWithChunkError'
import { useFetchPublicData } from 'state/hooks'
import { PublicRoute } from 'config/router/PublicRoute'
import { ProtectedRoute } from 'config/router/ProtectedRoute'
import 'bootstrap/dist/css/bootstrap.min.css';
import Withdraw from 'views/Withdraw'
import TokenWithdraw from 'views/Withdraw/TokenWithdraw'
import Games from 'views/GamefiTopGames'
import GameplayLoading from 'views/GameplayLoading'
import Blogs from 'views/Landing/Blogs'
import PrivacyPolicy from 'views/Landing/PrivacyPolicy'
import Legal from 'views/Landing/Legal'
import TermsandServices from 'views/Landing/TermsandServices'
import ScrollButton from 'components/ScrollBackToTop/ScrollToTop'
import Login from 'views/Forms/Login'
import Signup from 'views/Forms/Signup'
import ForgotPassword from 'views/Forms/ForgotPassword'
import ConfirmEmail from 'views/Forms/Signup/Confirmation'
import PasswordConfirm from 'views/Forms/ForgotPassword/PasswordConfirm'
import WithdrawDetails from 'views/Withdraw/WithdrawDetails'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VerifyEmail from 'views/Forms/Signup/VerifyEmail'
import { useAppDispatch } from 'state';
import { setUser } from 'state/user';
import { Route as ReactRoute } from 'react-router-dom';

const Landing = lazy(() => import('./views/Landing'))
const Home = lazy(() => import('./views/Home'))

const App: React.FC = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const token = localStorage.getItem('Gamesfi_Current_User');

        if (token) {
            dispatch(setUser({ authToken: token, user: null }));
        }
    }, []);

    // useFetchPublicData()

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <Router history={history}>
                <GlobalStyle />
                <SuspenseWithChunkError fallback={<PageLoader />}>

                    {/* <Web3ReactManager> */}
                    <Switch>

                        <ProtectedRoute path="/cashout" exact>
                            <Withdraw />
                        </ProtectedRoute>

                        <ProtectedRoute path="/withdrawdetail" exact>
                            <WithdrawDetails />
                        </ProtectedRoute>

                        <ProtectedRoute path="/tokenwithdraw" exact>
                            <TokenWithdraw />
                        </ProtectedRoute>

                        <ReactRoute path="/crypto-tiles" exact>
                            <GameplayLoading />
                        </ReactRoute>

                        <ProtectedRoute path="/home" exact>
                            <Home />
                        </ProtectedRoute>

                        <ProtectedRoute path="/games" exact>
                            <Games />
                        </ProtectedRoute>

                        <PublicRoute path="/" exact>
                            <Landing />
                        </PublicRoute>

                        <PublicRoute path="/blogs" exact>
                            <Blogs />
                        </PublicRoute>

                        <PublicRoute path="/privacypolicy" exact>
                            <PrivacyPolicy />
                        </PublicRoute>

                        <PublicRoute path="/legal" exact>
                            <Legal />
                        </PublicRoute>

                        <PublicRoute path="/termsandservices" exact>
                            <TermsandServices />
                        </PublicRoute>

                        <PublicRoute path="/login" exact>
                            <Login />
                        </PublicRoute>

                        <PublicRoute path="/signup" exact>
                            <Signup />
                        </PublicRoute>

                        <PublicRoute path="/forgotpassword" exact>
                            <ForgotPassword />
                        </PublicRoute>

                        <PublicRoute path="/confirmemail" exact>
                            <ConfirmEmail />
                        </PublicRoute>

                        <PublicRoute path="/passwordconfirm" exact>
                            <PasswordConfirm />
                        </PublicRoute>

                        <PublicRoute path="/verify" exact>
                            <VerifyEmail />
                        </PublicRoute>

                        <PublicRoute path="/passwordconfirmation" exact>
                            <PasswordConfirm />
                        </PublicRoute>

                        <Redirect from="*" to="/" />

                    </Switch>

                    {/* </Web3ReactManager> */}
                </SuspenseWithChunkError>

            </Router>

            <ScrollButton />
        </>

    );
}

export default App;
